import {StackScreenProps} from '@react-navigation/stack';
import {isValidPhoneNumber} from 'libphonenumber-js';
import {Box, Button, FormControl, WarningOutlineIcon} from 'native-base';
import React, {useEffect, useRef, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {TextInput} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {t} from 'react-native-tailwindcss';
import {KeyboardAvoidingView} from '../../components/KeyboardAvoidingView';
import {PhoneNumberInput} from '../../components/PhoneNumberInput';
import i18n from '../../lib/i18n';
import {Nav, NavParams} from '../navigation';

export const CreatePaymentPhoneScreen: React.FC<
  StackScreenProps<NavParams, Nav.CreatePaymentPhoneScreen>
> = ({navigation, route}) => {
  const inputRef = useRef<TextInput>(null);
  const {
    control,
    handleSubmit,
    formState: {errors}
  } = useForm({defaultValues: {phoneNumber: ''}});

  useEffect(() => {
    return navigation.addListener('transitionEnd', (nativeEvent) => {
      if (!nativeEvent.data.closing) {
        inputRef.current?.focus();
      }
    });
  }, [navigation]);

  const onSubmit = ({phoneNumber}: {phoneNumber: string}) => {
    navigation.navigate(Nav.CreatePaymentAmountScreen, {phoneNumber});
  };

  return (
    <SafeAreaView style={[t.flex1, t.bgWhite]} edges={['bottom']}>
      <KeyboardAvoidingView offset={125}>
        <Box style={[t.flex1, t.m4]}>
          <FormControl isInvalid={'phoneNumber' in errors}>
            <FormControl.Label>{i18n.t('toPhoneNumber')}</FormControl.Label>
            <Controller
              name="phoneNumber"
              control={control}
              defaultValue=""
              rules={{
                required: i18n.t('phoneNumberRequired'),
                validate: (value) => isValidPhoneNumber(value) || i18n.t('phoneNumberInvalid')
              }}
              render={({field: {onChange, onBlur, value}}) => (
                <PhoneNumberInput
                  autoFocus
                  countryCode={'ES'}
                  value={value}
                  onBlur={onBlur}
                  autoCorrect={false}
                  autoCapitalize="none"
                  onChangeText={onChange}
                  blurOnSubmit={false}
                  onSubmitEditing={handleSubmit(onSubmit)}
                  returnKeyType="next"
                  textContentType="telephoneNumber"
                  keyboardType="phone-pad"
                />
              )}
            />
            <FormControl.ErrorMessage leftIcon={<WarningOutlineIcon size="xs" />}>
              {errors?.phoneNumber?.message}
            </FormControl.ErrorMessage>
          </FormControl>
        </Box>
        <Box style={[t.p4]}>
          <Button onPress={handleSubmit(onSubmit)}>{i18n.t('continue')}</Button>
        </Box>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};
